<app-modal 
  [isOpen]="isOpen" 
  title="Hjælp" 
  (close)="onClose()">
  
  <div class="help-content">
    <div class="help-section">
      <h3>Brug for hjælp til din billet?</h3>
      <p>Hvis du oplever problemer med dit køb, kan du kontakte vores kundeservice.</p>
    </div>

   <div class="help-section">
      <h3>Subject</h3>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequa</p>
    </div>

   <div class="help-section">
      <h3>Subject</h3>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequa</p>
    </div>

    <div class="help-section">
      <h3>Subject</h3>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequa</p>
    </div>  
  </div>
</app-modal>
